import type { RouteObject } from "react-router-dom";
import AboutUsPage from "../components/about-us/pages/AboutUsPage";
import ManageReviewApprovalPage from "../components/admin/pages/ManageReviewApprovalPage";
import ManageTourAvailabilityPage from "../components/admin/pages/ManageTourAvailabilityPage";
import TermsOfBusinessPage from "../components/terms-of-business/pages/TermsOfBusinessPage";
import EquipmentPage from "../components/equipment/pages/EquipmentPage";
import GalleryPage from "../components/gallery/pages/GalleryPage";
import HomePage from "../components/home/pages/HomePage";
import HotelPage from "../components/hotel/pages/HotelPage";
import ReviewsPage from "../components/review/pages/ReviewsPage";
import SpecificOfferPage from "../components/specific-offer/pages/SpecificOfferPage";
import StaffMemberPage from "../components/staff-member/pages/StaffMemberPage";
import TourDetailsPage from "../components/tour-offer/pages/TourDetailsPage";
import NotFoundPage from "../components/not-found/pages/NotFoundPage";
import AboutUsContainer from "../layout/AboutUsContainer";
import Layout from "../layout/Layout";

let Routes: RouteObject[] = [
    {
        // path: "/",
        // element: <LandingPage />,

        element: <Layout />,
        children: [
            {
                path: "/",
                element: <HomePage />,
            },
            {
                path: "/tours",
                element: <TourDetailsPage />,
            },
            {
                path: "/reviews",
                element: <ReviewsPage />,
            },
            {
                path: "/gallery",
                element: <GalleryPage />,
            },
            {
                path: "/offer",
                element: <SpecificOfferPage />,
            },
            {
                path: "/hotel",
                element: <HotelPage />,
            },
            {
                path: "/equipment",
                element: <EquipmentPage />,
            },
            {
                path: "/terms-of-business",
                element: <TermsOfBusinessPage />,
            },
            {
                path: "/about-us",
                element: <AboutUsPage />,
            },
            {
                path: "/our-team",
                element: <StaffMemberPage />,
            },
            {
                path: "/manage-tour-availability/ver",
                element: <ManageTourAvailabilityPage />,
            },
            {
                path: "/manage-review-approval/ver",
                element: <ManageReviewApprovalPage />,
            },
            {
                path: "*",
                element: <NotFoundPage />,
            },
        ],
    },
    {

        element: <AboutUsContainer />,
        children: [
            {
                path: "/about-us",
                element: <AboutUsPage />,
            },
        ],
    },
];

export default Routes;
